<template>
  <div class="layout-store">
    <div id="appleid-signin" data-mode="logo-only" data-border-radius="50" class="signin-button" data-size="55%"
         data-color="black" data-border="true" data-type="sign in">
    </div>
  </div>
</template>

<script setup lang="ts">
import { getHashParam } from '@/utils/common';

const rootStore = useRootStore();
const router = useRouter();
const { $getCookie } = useNuxtApp();

onMounted(async () => {
  const token = getHashParam('id_token');
  const tokenData = token.split('.');

  if (!token || tokenData.length <= 1) {
    rootStore.showMessageDialog('페이지를 새로고침하고 다시 로그인해 주세요.\n문제가 계속되면 고객센터로 문의해주세요.', '확인', () => {
      router.push('/');
    });
    return;
  }

  let snsUserInfo: SnsUserInfo | null = null;

  try {
    const appleData = window.atob(tokenData[1]);
    
    snsUserInfo = {
      snsID: JSON.parse(appleData).sub,
      route : 'apple',
      nextUrl : getHashParam('state'), //decodeURIComponent(getHashParam('state'))
    };
  } catch (error) {
    console.error('apple data', error);
  }

  if (!snsUserInfo) {
    rootStore.showMessageDialog('페이지를 새로고침하고 다시 로그인해 주세요.\n문제가 계속되면 고객센터로 문의해주세요.', '확인', () => {
      router.push('/');
    });
    return;
  }

  if (await loginSNS(snsUserInfo)) {
    let nextUrl = snsUserInfo.nextUrl ? snsUserInfo.nextUrl : ($getCookie('afterLoginUrl') ?? '/');
    
    if (!nextUrl) nextUrl = '/';
    
    replaceUrl(nextUrl);
  }
});
</script>